export const CoffeeListPage = () => {
  return (
    <div>
      <h1>Coffee List</h1>
      <p>Welcome to the Coffee List Page!</p>
      {/* Add your coffee list components here */}
    </div>
  )
}